module.exports = __webpack_public_path__ + "img/class-room-home.8cf33d4c.jpg";